/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="93.9" height="92.96" viewBox="0 0 93.9 92.96" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="b798ed39-0913-418e-a324-1b8cadc50846" x="52.89" y="35" width="41.01" height="41.01" maskUnits="userSpaceOnUse">
            <g transform="translate(-30.5 -31)">
              <polygon points="83.39 66 124.4 66 124.4 107.01 83.39 107.01 83.39 66" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <g>
          <g>
            <line x1="61.4" y1="39.51" x2="42.4" y2="19.51" fill="none"/>
            <polygon points="43.48 18.47 62.48 38.47 60.31 40.54 41.31 20.54 43.48 18.47" fill="#094a79"/>
          </g>
          <g>
            <line x1="55.4" y1="63.51" x2="32.4" y2="71.51" fill="none"/>
            <polygon points="54.9 62.09 55.89 64.92 32.89 72.92 31.9 70.09 54.9 62.09" fill="#094a79"/>
          </g>
          <g>
            <path d="M47.43,90.06a16.95,16.95,0,1,0,15,9,16.85,16.85,0,0,0-15-9m0,3a14,14,0,1,1-6.56,1.65,13.93,13.93,0,0,1,6.56-1.65" transform="translate(-30.5 -31)" fill="#094a79" fillRule="evenodd"/>
            <g>
              <g mask="url(#b798ed39-0913-418e-a324-1b8cadc50846)">
                <path d="M103.88,66A20.51,20.51,0,1,0,122,76.84,20.38,20.38,0,0,0,103.88,66m0,3h0a17.51,17.51,0,1,1-8.23,2.07A17.49,17.49,0,0,1,103.88,69" transform="translate(-30.5 -31)" fill="#fcb61c" fillRule="evenodd"/>
              </g>
            </g>
            <path d="M66,31a11.42,11.42,0,1,0,10.07,6A11.32,11.32,0,0,0,66,31m0,3h0a8.42,8.42,0,1,1-4,1,8.4,8.4,0,0,1,4-1" transform="translate(-30.5 -31)" fill="#094a79" fillRule="evenodd"/>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'ThreeConnectedNodesIcon';

export default Icon;
